var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "closing-date-container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "label",
          {
            staticClass: "tender-status-label",
            attrs: { id: "edit-closing-date-tender-status-label" },
          },
          [_vm._v(_vm._s(_vm.$t("tender.status")) + ":")]
        ),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "status-severity",
            style: _vm.updateLabelColor(_vm.status),
            attrs: { id: "edit-closing-date-tender-status-value" },
          },
          [_vm._v(_vm._s(_vm.status))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "closing-date-label",
          attrs: { id: "edit-closing-date-label", for: "closingDate-select" },
        },
        [
          _vm._v(_vm._s(_vm.$t("tender.closingDate")) + ":\n      "),
          _c("span", { staticClass: "required-flag" }),
          _vm._v(" "),
          _c("span", { staticStyle: { "font-style": "italic" } }, [
            _vm._v(
              " (" +
                _vm._s(
                  _vm.$t("hint.closingDateHint", [
                    _vm.suggestedDaysITQ,
                    _vm.suggestedDaysTender,
                  ])
                ) +
                ")"
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", attrs: { id: "edit-closing-date-picker" } },
        [
          _c("DatePicker", {
            class: { "error-highlight": _vm.invalidClosingDate },
            attrs: {
              format: "DD MMM YY",
              disabled: _vm.disabledDates,
              calendarButton: true,
              calendarButtonIcon: "fa fa-calendar",
            },
            on: {
              selected: function (val) {
                return _vm.updateClosingDate(val, _vm.selectedClosingTime)
              },
            },
            model: {
              value: _vm.selectedClosingDate,
              callback: function ($$v) {
                _vm.selectedClosingDate = $$v
              },
              expression: "selectedClosingDate",
            },
          }),
          _vm._v(" "),
          _c("HKLSelect", {
            class: {
              "closing-time": !_vm.invalidClosingDate,
              "closing-time error-highlight": _vm.invalidClosingDate,
            },
            attrs: {
              value: _vm.selectedClosingTime || undefined,
              options: _vm.closingTimeHklOptions,
              showSearch: true,
              placeholder: "",
            },
            on: {
              change: function (val) {
                return _vm.updateClosingDate(_vm.selectedClosingDate, val || "")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "onsite-visit" }, [
        _c("div", { staticClass: "tender-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.onsiteVisitRequired,
                expression: "onsiteVisitRequired",
              },
            ],
            attrs: {
              disabled:
                _vm.onsiteVisitRequired && !_vm.onsiteContact.changedFlag,
              id: "edit-closing-date-onsite-visit-required",
              type: "checkbox",
            },
            domProps: {
              checked: Array.isArray(_vm.onsiteVisitRequired)
                ? _vm._i(_vm.onsiteVisitRequired, null) > -1
                : _vm.onsiteVisitRequired,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.onsiteVisitRequired,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.onsiteVisitRequired = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.onsiteVisitRequired = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.onsiteVisitRequired = $$c
                  }
                },
                function (event) {
                  return _vm.updateOnsiteInfo(event.target.checked)
                },
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { attrs: { id: "edit-closing-date-onsite-visit-required-label" } },
            [_vm._v(_vm._s(_vm.$t("tender.general.onsiteVisitRequired")))]
          ),
        ]),
        _vm._v(" "),
        _vm.onsiteVisitRequired
          ? _c("div", [
              _c(
                "label",
                {
                  staticClass: "tender-label onsite-location__label",
                  attrs: { id: "edit-closing-date-onsite-location-label" },
                },
                [_vm._v(_vm._s(_vm.$t("tender.general.onSiteLocation")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.onsiteLocation,
                    expression: "onsiteLocation",
                  },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      tip: _vm.$t("hint.inputTip.location"),
                    },
                    expression:
                      "{type: 'string', tip: $t('hint.inputTip.location'),}",
                  },
                ],
                staticClass: "onsite-location",
                class: {
                  "error-highlight":
                    !_vm.onsiteLocation && _vm.invalidContactInfo,
                },
                attrs: {
                  type: "text",
                  id: "edit-closing-date-onsite-location-value",
                  placeholder: _vm.$t("tender.general.onSiteLocation"),
                  required: "",
                },
                domProps: { value: _vm.onsiteLocation },
                on: {
                  change: function (event) {
                    return _vm.updateOnsiteLocation(event.target.value)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.onsiteLocation = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "tender-label onsite-contact__label",
                  attrs: { id: "edit-closing-date-onsite-contact-label" },
                },
                [_vm._v(_vm._s(_vm.$t("tender.general.onSiteContact")))]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      tip: _vm.$t("hint.inputTip.name"),
                    },
                    expression:
                      "{type: 'string', tip: $t('hint.inputTip.name'),}",
                  },
                ],
                staticClass: "onsite-contact",
                class: {
                  "error-highlight":
                    !_vm.onsiteContact.name && _vm.invalidContactInfo,
                },
                attrs: {
                  type: "text",
                  id: "edit-closing-date-onsite-contact-name",
                  placeholder: _vm.$t("user.name"),
                  required: "",
                },
                domProps: { value: _vm.onsiteContact.name },
                on: {
                  change: function (event) {
                    return _vm.updateContact(
                      ["general", "onsiteContact", "name"],
                      event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      tip: _vm.$t("hint.inputTip.email"),
                      pattern: _vm.email,
                    },
                    expression:
                      "{type: 'string', tip: $t('hint.inputTip.email'), pattern: email}",
                  },
                ],
                staticClass: "onsite-contact",
                class: {
                  "error-highlight":
                    !_vm.onsiteContact.email && _vm.invalidContactInfo,
                },
                attrs: {
                  type: "text",
                  id: "edit-closing-date-onsite-contact-email",
                  placeholder: _vm.$t("user.email"),
                  required: "",
                },
                domProps: { value: _vm.onsiteContact.email },
                on: {
                  change: function (event) {
                    return _vm.updateContact(
                      ["general", "onsiteContact", "email"],
                      event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      tip: _vm.$t("hint.inputTip.phone"),
                      pattern: _vm.phone,
                    },
                    expression:
                      "{type: 'string', tip: $t('hint.inputTip.phone'), pattern: phone}",
                  },
                ],
                staticClass: "onsite-contact",
                class: {
                  "error-highlight":
                    !_vm.onsiteContact.phone && _vm.invalidContactInfo,
                },
                attrs: {
                  type: "text",
                  id: "edit-closing-date-onsite-contact-phone",
                  placeholder: _vm.$t("user.phone"),
                  required: "",
                },
                domProps: { value: _vm.onsiteContact.phone },
                on: {
                  change: function (event) {
                    return _vm.updateContact(
                      ["general", "onsiteContact", "phone"],
                      event.target.value
                    )
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "edit-closing-date-vendors" } }, [
        _c("table", [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("vendor.invitedVendors")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("vendor.onSiteVisitDateTime")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("vendor.status")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("handover.lastUpdateOn")))]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.bids, function (bid, index) {
              return _c("tr", { key: index }, [
                _c("td", { staticClass: "vendor-name" }, [
                  _vm._v(_vm._s(_vm.deep(bid, "company.name") || "")),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "visit-date row",
                    class: {
                      "error-highlight":
                        _vm.isAfterClosingDate[index] ||
                        (_vm.highlightflags[index] &&
                          _vm.invalidVisitDayAndTime),
                    },
                    attrs: { id: "edit-closing-date-vendors-" + index },
                  },
                  [
                    _c("div", { staticClass: "clear-date" }, [
                      _vm.showClearIcon(_vm.onsiteVisitTimes[index])
                        ? _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.updateVisitDate(index)
                                },
                              },
                            },
                            [_vm._m(0, true)]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("DatePicker", {
                      attrs: {
                        disabledPicker: !_vm.onsiteVisitRequired,
                        format: "DD MMM YY",
                        disabled: _vm.onSiteVisiteDisabledDates(),
                        clearButton: false,
                        calendarButton: true,
                        calendarButtonIcon: "fa fa-calendar",
                        value: _vm.onsiteVisitTimes[index].visitDay,
                      },
                      on: {
                        selected: function (val) {
                          return _vm.updateVisitDate(
                            index,
                            val,
                            _vm.onsiteVisitTimes[index].visitTime
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("HKLSelect", {
                      staticClass: "visit-time",
                      attrs: {
                        disabled: !_vm.onsiteVisitRequired,
                        value:
                          _vm.onsiteVisitTimes[index].visitTime || undefined,
                        options: _vm.visitTimeHklOptions,
                        showSearch: true,
                        placeholder: "",
                      },
                      on: {
                        change: function (val) {
                          return _vm.updateVisitDate(
                            index,
                            _vm.onsiteVisitTimes[index].visitDay,
                            val || ""
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "vendor-status",
                    attrs: { id: "edit-closing-date-vendors-status-" + index },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.bidStatus(bid)) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "vendor-respond-date" }, [
                  bid.respondedOn || bid.startBidAt
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.formatLastSubmittedOn(bid))),
                      ])
                    : _vm._e(),
                ]),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.isTenderInAddendum
          ? _c("div", { staticClass: "status-summary" }, [
              _c("label", [_vm._v("SUBMITTED:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.totalSubmittedbids(_vm.bids)))]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("span", {
        staticClass: "fa fa-times fa-lg",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }